import {REGISTER_CAPTCHA_RESPONSE, REGISTER_SUBMIT_FAILURE, RESET_PASSWORD_FAILURE} from '../actions/AccountActions';

const initialState = {
    captchaResponse: null,
};

export function captcha(state = initialState, action) {
    switch (action.type) {
        case REGISTER_CAPTCHA_RESPONSE: {
            const {captchaResponse} = action;
            return {captchaResponse};
        }
        case RESET_PASSWORD_FAILURE:
        case REGISTER_SUBMIT_FAILURE: {
            return initialState;
        }
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/captcha.js